import * as React from 'react'

import { Helmet } from 'react-helmet-async'
import { GenerateImagesLayout } from '../../layouts/MediaLibrary'

const GenerateImagesPage = (): React.ReactElement => (
  <>
    <Helmet>
      <title>Generate images using AI</title>
      <meta name="description" content="ImageKit notifications" />
    </Helmet>
    <GenerateImagesLayout />
  </>
)

export default GenerateImagesPage
